
import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";
import Index from "./pages/Index";
import Services from "./pages/Services";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import BookingPage from "./pages/BookingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCanceledPage from "./pages/PaymentCanceledPage";
import ProjectPaymentPage from "./pages/ProjectPaymentPage";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import About from "./pages/About";
import Portfolio from "./pages/services/Portfolio";
import Process from "./pages/services/Process";
import CaseStudy from "./pages/services/CaseStudy";
import AICodeSecurity from "./pages/services/AICodeSecurity";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import AIConsultant from "./pages/AIConsultant";
import WordPressPlugins from "./pages/WordPressPlugins";
import PluginDetail from "./pages/PluginDetail";
import LovaSignature from "./pages/LovaSignature";

// No-code funnel pages
import NocodeIndex from "./pages/nocode/Index";
import NocodeOnboarding from "./pages/nocode/Onboarding";
import NocodePayment from "./pages/nocode/Payment";
import NocodeThankYou from "./pages/nocode/ThankYou";
import AIVideoOnboarding from "./pages/ai-video/AIVideoOnboarding";

// Create a Root component to wrap normal pages
const Root = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

// Create a NoCode Root component without Navbar but with Footer
const NoCodeRoot = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <Footer />
    </>
  );
};

// Create an ErrorPage component
const ErrorPage = () => {
  return <NotFound />;
};

const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Index />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/services/portfolio",
        element: <Portfolio />,
      },
      {
        path: "/services/portfolio/:id",
        element: <CaseStudy />,
      },
      {
        path: "/services/process",
        element: <Process />,
      },
      {
        path: "/services/ai-code-security",
        element: <AICodeSecurity />,
      },
      {
        path: "/booking",
        element: <BookingPage />,
      },
      {
        path: "/auth",
        element: <Auth />,
      },
      {
        path: "/payment-success",
        element: <PaymentSuccessPage />,
      },
      {
        path: "/payment-canceled",
        element: <PaymentCanceledPage />,
      },
      {
        path: "/payment",
        element: <ProjectPaymentPage />,
      },
      {
        path: "/project-payment",
        element: <ProjectPaymentPage />,
      },
      {
        path: "/admin",
        element: (
          <ProtectedRoute requireAdmin={true}>
            <AdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/privacy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/terms",
        element: <TermsOfUse />,
      },
      {
        path: "/ai-consultant",
        element: <AIConsultant />,
      },
      {
        path: "/wordpress-plugins",
        element: <WordPressPlugins />,
      },
      {
        path: "/wordpress-plugins/:slug",
        element: <PluginDetail />,
      },
    ],
  },
  // No-code funnel routes with their own layout
  {
    element: <NoCodeRoot />,
    children: [
      {
        path: "/nocode",
        element: <NocodeIndex />,
      },
      {
        path: "/nocode/onboarding",
        element: <NocodeOnboarding />,
      },
      {
        path: "/nocode/payment",
        element: <NocodePayment />,
      },
      {
        path: "/nocode/thank-you",
        element: <NocodeThankYou />,
      },
      {
        path: "/ai-video/onboarding",
        element: <AIVideoOnboarding />,
      },
    ],
  },
  // LovaSignature - standalone page with minimal layout
  {
    path: "/lovasignature",
    element: (
      <>
        <ScrollToTop />
        <LovaSignature />
      </>
    ),
  },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
